if (!customElements.get('cookie-consent')) {
  customElements.define('cookie-consent', class extends HTMLElement {
    connectedCallback() {
      if (this.initialized) return;
      this.initialized = true;
      let dismissed = false;
      try { dismissed = sessionStorage.getItem('ff-cookie-notice-dismissed') === 'true'; } catch (_) {}
      if (getCookie('cookie-consent') || dismissed) { this.remove(); return; }
      this.previousPadding = document.body.style.paddingBottom;
      this.mobile = matchMedia('(max-width: 750px)');
      this.updateSpacing = () => {
        if (!this.isConnected) return;
        document.body.style.paddingBottom = !this.mobile.matches && this.classList.contains('full-width') ? this.offsetHeight + 'px' : this.previousPadding;
      };
      this.querySelector('[data-accept-cookie]')?.addEventListener('click', event => {
        event.preventDefault();
        setCookie('cookie-consent', 'accepted', 365);
        this.remove();
      });
      this.querySelector('[data-close-cookie]')?.addEventListener('click', event => {
        event.preventDefault();
        try { sessionStorage.setItem('ff-cookie-notice-dismissed', 'true'); } catch (_) {}
        this.remove();
      });
      this.style.display = 'block';
      this.mobile.addEventListener('change', this.updateSpacing);
      this.observer = new ResizeObserver(this.updateSpacing);
      this.observer.observe(this);
      this.updateSpacing();
    }
    disconnectedCallback() {
      this.observer?.disconnect();
      this.mobile?.removeEventListener('change', this.updateSpacing);
      if (this.previousPadding !== undefined) document.body.style.paddingBottom = this.previousPadding;
    }
  });
}
